export default __webpack_public_path__ + "static/dental-chews-991fc427471fb8412436e97bb6a0c8af.jpg";